import { useTranslation } from 'react-i18next';
import { FeedItem } from 'types/feeds';
import styles from './FeedItemCard.module.scss';

function UpcomingStatusBadge() {
  const { t } = useTranslation();

  return (
    <div className={styles.upcomingStatusBadge}>
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="18" height="18" rx="9" fill="#C3C8FE" />
        <circle cx="9.00112" cy="8.9999" r="4.57143" fill="#0030E2" stroke="#6681FF" strokeWidth="4" />
      </svg>

      <span>{t('feed.status.upcoming')}</span>
    </div>
  );
}

function OpenStatusBadge() {
  const { t } = useTranslation();

  return (
    <div className={styles.openStatusBadge}>
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="18" height="18" rx="9" fill="#7CE5BF" />
        <circle cx="9.00112" cy="8.9999" r="4.57143" fill="#08823D" stroke="#24D394" strokeWidth="4" />
      </svg>

      <span>{t('feed.status.open')}</span>
    </div>
  );
}

function ClosedStatusBadge() {
  const { t } = useTranslation();

  return (
    <div className={styles.closedStatusBadge}>
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="18" height="18" rx="9" fill="#FFD9E0" />
        <circle cx="9.00112" cy="8.9999" r="4.57143" fill="#EB0010" stroke="#FF6978" strokeWidth="4" />
      </svg>

      <span>{t('feed.status.closed')}</span>
    </div>
  );
}

interface StatusBadgeProps {
  status: FeedItem['status'];
}

export function StatusBadge({ status }: StatusBadgeProps): React.ReactNode {
  switch (status) {
    case 'upcoming':
      return <UpcomingStatusBadge />;
    case 'open':
      return <OpenStatusBadge />;
    case 'closed':
      return <ClosedStatusBadge />;
    default:
      return null;
  }
}
